import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const testimonialApi = {
  getTestimonials: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.TESTIMONIALS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      throw error;
    }
  },

  getTestimonialByIdentifier: async (identifier) => {
    try {
      const url = `${API_ENDPOINTS.TESTIMONIALS}/${identifier}`;
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createTestimonial: async (testimonialData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.TESTIMONIALS}`, testimonialData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating testimonial:', error);
      throw error;
    }
  },

  updateTestimonial: async (identifier, testimonialData) => {
    try {
      testimonialData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.TESTIMONIALS}/${identifier}`, testimonialData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating testimonial ${identifier}:`, error);
      throw error;
    }
  },

  trashTestimonial: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.TESTIMONIALS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing testimonial ${identifier}:`, error);
      throw error;
    }
  },

  restoreTestimonial: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.TESTIMONIALS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring testimonial ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteTestimonial: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.TESTIMONIALS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting testimonial ${identifier}:`, error);
      throw error;
    }
  },
};

export default testimonialApi;